
import React from "react";
import {VIEW_TYPE} from '../../../../../enums/ViewType';
import ContractorsTable from './ContractorsTable';
import ContractorsCards from './ContractorsCards';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ContractorsTab = (props) => {
    const {
        view,
        setView,
        searchElement,
        setSearchElement,
        isAllCheckedContractor, setIsAllCheckedContractor,
        selectedList,setSelectedList,
        search, setSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        bodyForExport, setBodyForExport,
        modified,
        setModified,
        finalArray,
        setCriteria,
    } = props;

    return (
        <>

            {view === VIEW_TYPE.GRID.name && (
                <>
                    <ContractorsCards
                        contractorId={contractorId}
                        supplierId={supplierId}
                        view={view}
                        setView={setView}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        search={search}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        finalArray={finalArray}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        isAllChecked={isAllCheckedContractor}
                        setIsAllChecked={setIsAllCheckedContractor}
                        setCriteria={setCriteria}
                        modified={modified}
                        setModified={setModified}
                        bodyForExport={bodyForExport}
                        setBodyForExport={setBodyForExport}
                    />
                </>
            )}

            {view === VIEW_TYPE.LIST.name && (
                <ContractorsTable
                    contractorId={contractorId}
                    supplierId={supplierId}
                    view={view}
                    setView={setView}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    search={search}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    finalArray={finalArray}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    isAllChecked={isAllCheckedContractor}
                    setIsAllChecked={setIsAllCheckedContractor}
                    setCriteria={setCriteria}
                    modified={modified}
                    setModified={setModified}
                    bodyForExport={bodyForExport}
                    setBodyForExport={setBodyForExport}
                />
            )}
        </>
    );
};
export default ContractorsTab;
